<div class="flex flex-col" *ngIf="vm$ | async">
	<form
		#form="ngForm"
		class="flex flex-col px-0.5 justify-between overflow-hidden gap-4"
	>
		<app-input
			class="w-full"
			label="Title"
			[placeholder]="originalTitle"
			[(ngModel)]="description"
			(debounce)="updateDescription($event)"
			[required]="true"
			name="description"
		></app-input>
		<div class="text-sm text-grey">
			Original title: <span class="font-bold">{{ originalTitle }}</span>
		</div>
		<span
			class="text-sm text-green hover:underline hover:cursor-pointer"
			(click)="goToItem(trustLedgerItem)"
		>
			View Sale Price
		</span>
		<div class="mt-5" data-intercom-target="sale-price-itemization">
			<div class="flex flex-row justify-between items-center">
				<p class="text font-bold">Balance due on closing</p>
				<p class="text font-bold">
					{{ trustLedgerItem?.amount | centsToDollars }}
				</p>
			</div>
			<div class="mt-3 text-sm text-grey" *ngIf="overrideAdjustments">
				Amount has been overridden in Adjustments
			</div>
			<div class="mt-7">
				<app-sale-price-itemization
					[isDrawerOpen]="true"
					[trustLedgerItem]="(vm$ | async).trustLedgerItem"
				></app-sale-price-itemization>
			</div>
		</div>
	</form>
</div>
